import * as React from "react";
import { Card } from "@material-tailwind/react";

import { KpiSection } from './KPI';
import { DashboardChart } from './Chart';
import { DashboardPayouts } from './Payouts';
import { DashboardVehicleDeliveryWeek } from './VehicleDeliveryWeek';
import { DashboardTodaysBids } from './TodaysBids';
import { DashboardInventoryUpdate } from './InventoryUpdate';
import { RootState } from "../../../redux";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useState } from "react";


const DashboardHome = () => {
    const navigate = useNavigate();
    const { auth } = useSelector((state: RootState) => state.auth);
    const [isAdmin, setIsAdmin] = useState(false);

    React.useEffect(() => {
        if (!["SuperUser", "Admin"].includes(auth?.user?.role?.title || "")) {
            navigate("/dashboard/vehicles/inventory");
        } else {
            setIsAdmin(true);
        }
    }, [auth, navigate]);

    return ( !isAdmin ? null : (
        <div className="flex flex-col gap-y-5 text-black w-full">
            <KpiSection className="bg-white w-full p-5 mt-5 rounded-lg" />

            <div className="flex flex-col md:flex-row w-full gap-5">
                <Card className="rounded-lg items-center w-full md:w-2/3 p-5">
                    <DashboardChart />
                </Card>
                <Card className="rounded-lg items-center w-full md:w-1/3">
                    <DashboardPayouts />
                </Card>
            </div>

            <div className="flex flex-col md:flex-row w-full gap-5">
                <Card className="rounded-lg items-center w-full">
                    <DashboardVehicleDeliveryWeek />
                </Card>
            </div>

            <div className="flex flex-col md:flex-row w-full gap-5">
                <DashboardTodaysBids />
            </div>

            <div className="flex flex-col md:flex-row w-full gap-5">
                <DashboardInventoryUpdate />
            </div>
        </div>
    ));
};

export default DashboardHome;
